import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthDropdown from "./AuthDropdown";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("main-content") as HTMLElement);

root.render(<App />);

const menuElement = document.querySelector(".et_pb_row--with-menu") as HTMLElement;

if (menuElement) {
  // Button element exists only on the dashboard page
  const buttonElement = document.querySelector(".et_pb_section--with-menu .et_pb_button") as HTMLLinkElement;
  const dropdownElement = document.createElement("div");
  dropdownElement.id = "myjr-auth-dropdown";
  menuElement.appendChild(dropdownElement);
  if (buttonElement) {
    buttonElement.remove();
    const dropdown = ReactDOM.createRoot(document.getElementById("myjr-auth-dropdown") as HTMLElement);
    dropdown.render(<AuthDropdown />);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
